module.exports = __webpack_public_path__ + "media/app/assets/regions/US-9b77d3ce958143a824b9afc4699d560b.png";